import { useFavicon, useTitle } from '@vueuse/core'
import { useI18n } from 'vue-i18n'

interface UseMetaReturn {
  setMetaDescriptionAndFavicon: (
    logo: string,
    merchantName: string,
    backgroundColor: string,
  ) => void
  setNavigatorColor: (color: string) => void
}

export default function useMeta(): UseMetaReturn {
  const { t } = useI18n()
  const icon = useFavicon()
  const title = useTitle()

  const setMetaDescriptionAndFavicon = (
    logoUrl: string,
    merchantName: string,
    backgroundColor: string,
  ) => {
    const logo = logoUrl
    icon.value = logo
    title.value = t('meta.title', { merchantName: merchantName })

    const metaColor = document.querySelector("meta[name='theme-color']")
    metaColor?.setAttribute('content', backgroundColor)
  }

  const setNavigatorColor = (color?: string) => {
    const metaColor = document.querySelector("meta[name='theme-color']")
    metaColor?.setAttribute('content', color ?? '#ffffff')
  }

  return {
    setMetaDescriptionAndFavicon,
    setNavigatorColor,
  }
}
